export class ResetFormRequestModel {
	constructor(
		public FormId: number,
		public EntityId: number,
		public TableTypeId: number,
		public FieldCollectionId: number,
		public FormTypeId: number) {

	}
}